export  default {
    'confDate': ' 27-28 June, 2025',
    'extension': '10 April, 2023',
    'PaperSubmission': '24 January, 2025',
    'PaperSubmissionDay': '24',
    'Notification': '17 April, 2025',
    'NotificationDay': '17',
    'CameraReady': '15 May, 2025',
    'CameraReadyDay': '15',
    'RegistrationDeadline': '15 May, 2025',
    'RegistrationDeadlineDay': '15',
    //apiUrlLaravel: 'http://127.0.0.1:8000/api',
    production: 'https://confncim.org/ipn',
    dev: 'http://localhost:3000/ipn',
    apiUrlLaravel: 'https://admin.confncim.org/api',
    apiUrlImage: 'https://admin.confncim.org/api/upload'
}